import getEnvironDomain from 'ati-utils/getEnvironDomain';

export const hostname = getEnvironDomain();

export const helpHostname = `help.${hostname}`;
